module.exports = __webpack_public_path__ + "img/step2.51d3c571.png";